import React, { useEffect, useState } from 'react';
import '../style/sidebar.css';
import { Link, useNavigate } from 'react-router-dom';
import { useAppId } from '../context/AppIdContext';

/* Professional modern outline icons (Lucide-style) — sidebar only */
const NavIcon = ({ children }) => (
    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {children}
    </svg>
);

const I = {
    dashboard: <NavIcon><rect x="3" y="3" width="7" height="9" rx="1.5" /><rect x="14" y="3" width="7" height="5" rx="1.5" /><rect x="14" y="12" width="7" height="9" rx="1.5" /><rect x="3" y="16" width="7" height="5" rx="1.5" /></NavIcon>,
    admin: <NavIcon><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M9 12l2 2 4-4" /></NavIcon>,
    users: <NavIcon><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></NavIcon>,
    user: <NavIcon><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></NavIcon>,
    party: <NavIcon><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></NavIcon>,
    headphones: <NavIcon><path d="M3 18v-6a9 9 0 0 1 18 0v6" /><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" /></NavIcon>,
    megaphone: <NavIcon><path d="M3 11l18-5v12L3 13v-2z" /><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" /></NavIcon>,
    building: <NavIcon><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18" /><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" /><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" /><path d="M10 6h4M10 10h4M10 14h4M10 18h4" /></NavIcon>,
    organization: <NavIcon><circle cx="12" cy="5" r="2.5" /><circle cx="5" cy="19" r="2.5" /><circle cx="19" cy="19" r="2.5" /><path d="M12 7.5v3.5M12 11l-5.5 5.5M12 11l5.5 5.5" /></NavIcon>,
    search: <NavIcon><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></NavIcon>,
    phonebook: <NavIcon><path d="M4 4h12a2 2 0 0 1 2 2v14l-4-2-4 2-4-2-4 2V6a2 2 0 0 1 2-2z" /><path d="M9 8h6M9 12h6" /></NavIcon>,
    surnameGroup: <NavIcon><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 11h-6M19 8v6" /></NavIcon>,
    group: <NavIcon><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></NavIcon>,
    send: <NavIcon><path d="M22 2L11 13" /><path d="M22 2l-7 20-4-9-9-4 20-7z" /></NavIcon>,
    mic: <NavIcon><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" /><path d="M19 10v1a7 7 0 0 1-14 0v-1" /><path d="M12 18v4M8 22h8" /></NavIcon>,
    zap: <NavIcon><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" /></NavIcon>,
    booth: <NavIcon><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" /><path d="M3.3 7L12 12l8.7-5M12 22V12" /></NavIcon>,
    mapPin: <NavIcon><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></NavIcon>,
    clock: <NavIcon><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></NavIcon>,
    tag: <NavIcon><path d="M12 2H2v10l9.29 9.29a1 1 0 0 0 1.41 0l8.59-8.59a1 1 0 0 0 0-1.41L12 2z" /><circle cx="7.5" cy="7.5" r="1.5" /></NavIcon>,
    scan: <NavIcon><path d="M3 7V5a2 2 0 0 1 2-2h2M3 17v2a2 2 0 0 0 2 2h2M21 7V5a2 2 0 0 0-2-2h-2M21 17v2a2 2 0 0 1-2 2h-2" /><path d="M7 12h10" /></NavIcon>,
    clipboard: <NavIcon><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M15 2H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" /><path d="M9 12h6M9 16h4" /></NavIcon>,
    fileText: <NavIcon><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M8 13h8M8 17h6" /></NavIcon>,
    phone: <NavIcon><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" /></NavIcon>,
    gift: <NavIcon><path d="M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8" /><path d="M2 7h20v5H2z" /><path d="M12 22V7" /><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" /><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" /></NavIcon>,
    chart: <NavIcon><path d="M18 20V10M12 20V4M6 20v-6" /></NavIcon>,
    star: <NavIcon><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" /></NavIcon>,
    share: <NavIcon><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98" /></NavIcon>,
    video: <NavIcon><path d="M15 10l4.55-2.28A1 1 0 0 1 21 8.62v6.76a1 1 0 0 1-1.45.89L15 14" /><rect x="3" y="6" width="12" height="12" rx="2" /></NavIcon>,
    globe: <NavIcon><circle cx="12" cy="12" r="9" /><path d="M3.6 9h16.8M3.6 15h16.8" /><path d="M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z" /></NavIcon>,
    changeRole: <NavIcon><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 11l-3-3m0 0l-3 3m3-3v8" /></NavIcon>,
    settings: <NavIcon><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></NavIcon>,
    logout: <NavIcon><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></NavIcon>,
};

const Sidebar = () => {
    // --- THE FIX: Pulled in setUserType and other setters to sync context properly ---
    const {
        appId, setAppId,
        userName, setUserName,
        userPhoto, setUserPhoto,
        language, setLanguage,
        userType, setUserType,
        setUserId, setTotalVoters,
        logout,
        aacharSahita,
        prachar
    } = useAppId();

    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    // --- Role Verification Logic ---
    const activeRole = userType || localStorage.getItem('userType') || localStorage.getItem('designation') || localStorage.getItem('role');
    const roleCode = activeRole ? activeRole.toUpperCase() : 'A';

    const isAdmin = roleCode === 'A' || roleCode === 'ADMIN';
    const isSubAdmin = roleCode === 'SA' || roleCode === 'SUB_ADMIN';
    const isShaktiKendra = roleCode === 'SP' || roleCode === 'SHAKTI_KENDRA';
    const isBoothPramukh = roleCode === 'BP' || roleCode === 'BOOTH_PRAMUKH';
    const isSahBoothPramukh = roleCode === 'BS' || roleCode === 'SAH_BOOTH_PRAMUKH';
    const isKaryakarta = roleCode === 'K' || roleCode === 'KARYAKARTA';
    const isCallCenter = roleCode === 'CL' || roleCode === 'CALL_CENTER';
    const isVoterCaptain = roleCode === 'VC' || roleCode === 'VOTER_CAPTAIN';
    const isWarroomPramukh = roleCode === 'WP' || roleCode === 'WARROOM_PRAMUKH';
    const isBoothCaptain = roleCode === 'BC' || roleCode === 'BOOTH_CAPTAIN';
    const isLiveVotingUser = roleCode === 'LV' || roleCode === 'LIVE_VOTING';

    // --- 1. Manual Translation Dictionary ---
    const t = {
        en: {
            dashboard: "Dashboard",
            admin: "Admin",
            subAdmin: "Sub Admin",
            boothPramukh: "Booth Pramukh",
            sahBoothPramukh: "Sah Booth Pramukh",
            shaktiKendra: "Shakti Kendra",
            volunteers: "Volunteers",
            callCenter: "Call Center",
            masterSearch: "Master Search",
            speakSearch: "Speak And Search",
            quickSearch: "Quick Search",
            boothWise: "Booth Wise Voters",
            pollingWise: "Polling Wise Voters",
            ageWise: "Age wise Voters",
            surnameWise: "Surname Wise",
            scanId: "SCAN ID",
            language: "Language",
            settings: "Settings",
            cadresLabel: "Cadres",
            masterSearchLabel: "Master Search",
            reportsLabel: "Reports",
            slipSendingReport: "Slip Sending Report",
            surveyWiseReport: "Cadre Wise Survey Report",
            survey: "Survey",
            callCenterReport: "Call Center Survey Report",
            communicationLabel: "Communication & Groups",
            myPhonebook: "My Phonebook",
            myGroup: "My Group",
            surnameGroup: "Surname Group",
            preferencesLabel: "Preferences",
            adminBadge: "Admin",
            wallet: "Wallet",
            logoutConfirmTitle: "Logout Confirmation",
            logoutConfirmMessage: "Are you sure you want to logout?",
            logoutCancel: "Cancel",
            logoutConfirm: "Yes, Logout",
            bulkSlipPrint: "Bulk Slip Print",
            changeResp: "Change Responsibility",
            partyCader: "Party Cader",
            personalCader: "Personal Cader",
            beneficiary: "Beneficiary",
            liveVoting: "Live Voting",
            bulkPrachar: "Bulk Prachar",
            pracharMaster: "Prachar Master",
            starVolunteer: "Star Volunteer",
            allUsers: "All Users",
            helpVideo: "Help Video",
            socialMedia: "Youth & Social Media",
            mySlipSending: "My Slip Sending",
            myPhonebookSlip: "My Phonebook Slip",
            voterCaptain: "Voter Captain",
            warroomPramukh: "Warroom Pramukh",
            boothCaptain: "Booth Captain",
            liveVotingUser: "Live Voting User",
            myOrganization: "My Organization",
            myVoter: "My Voter",
            voterList: "Voter List",
            socialUpdate: "Social Update",
            profile: "Profile",
        },
        hi: {
            dashboard: "डैशबोर्ड",
            admin: "एडमिन",
            subAdmin: "सब एडमिन",
            boothPramukh: "बूथ प्रमुख",
            sahBoothPramukh: "सह बूथ प्रमुख",
            shaktiKendra: "शक्ति केंद्र",
            volunteers: "कार्यकर्ता",
            callCenter: "कॉल सेंटर",
            masterSearch: "मास्टर खोज",
            speakSearch: "बोलकर खोजें",
            quickSearch: "त्वरित खोज",
            boothWise: "बूथ वार मतदाता",
            pollingWise: "पोलिंग वार मतदाता",
            ageWise: "आयु वार मतदाता",
            surnameWise: "सरनेम वार",
            scanId: "स्कैन आईडी",
            language: "भाषा",
            settings: "सेटिंग्स",
            cadresLabel: "कैडर",
            masterSearchLabel: "मास्टर सर्च",
            reportsLabel: "रिपोर्ट्स",
            slipSendingReport: "पर्ची भेजने की रिपोर्ट",
            surveyWiseReport: "कैडर वार सर्वेक्षण रिपोर्ट",
            survey: "सर्वेक्षण",
            callCenterReport: "कॉल सेंटर सर्वेक्षण रिपोर्ट",
            communicationLabel: "संचार और समूह",
            myPhonebook: "मेरी फोनबुक",
            myGroup: "मेरा समूह",
            surnameGroup: "उपनाम समूह",
            preferencesLabel: "प्राथमिकताएं",
            adminBadge: "प्रशासक",
            wallet: "वॉलेट",
            logoutConfirmTitle: "लॉगआउट की पुष्टि",
            logoutConfirmMessage: "क्या आप वाकई लॉगआउट करना चाहते हैं?",
            logoutCancel: "रद्द करें",
            logoutConfirm: "हाँ, लॉगआउट करें",
            bulkSlipPrint: "थोक पर्ची प्रिंट",
            changeResp: "जिम्मेदारी बदलें",
            partyCader: "पार्टी कैडर",
            personalCader: "व्यक्तिगत कैडर",
            beneficiary: "लाभार्थी",
            liveVoting: "लाइव वोटिंग",
            bulkPrachar: "बल्क प्रचार",
            pracharMaster: "प्रचार मास्टर",
            starVolunteer: "स्टार वॉलंटियर",
            allUsers: "सभी उपयोगकर्ता",
            helpVideo: "सहायता वीडियो",
            socialMedia: "युवा और सोशल मीडिया",
            mySlipSending: "मेरी स्लिप भेजना",
            myPhonebookSlip: "मेरी फोनबुक स्लिप",
            voterCaptain: "वोटर कैप्टन",
            warroomPramukh: "वाररूम प्रमुख",
            boothCaptain: "बूथ कैप्टन",
            liveVotingUser: "लाइव वोटिंग यूजर",
            myOrganization: "मेरा संगठन",
            myVoter: "मेरा मतदाता",
            voterList: "मतदाता सूची",
            socialUpdate: "सोशल अपडेट",
            profile: "प्रोफ़ाइल",
        },
        gu: {
            dashboard: "ડેશબોર્ડ",
            admin: "એડમિન",
            subAdmin: "સબ એડમિન",
            boothPramukh: "બૂથ પ્રમુખ",
            sahBoothPramukh: "સહ બૂથ પ્રમુખ",
            shaktiKendra: "શક્તિ કેન્દ્ર",
            volunteers: "કાર્યકર્તા",
            callCenter: "કૉલ સેન્ટર",
            masterSearch: "માસ્ટર શોધ",
            speakSearch: "બોલીને શોધો",
            quickSearch: "ઝડપી શોધ",
            boothWise: "બૂથ મુજબ મતદારો",
            pollingWise: "મતદાન મથક મુજબ મતદારો",
            ageWise: "ઉંમર મુજબ મતદારો",
            surnameWise: "અટક મુજબ",
            scanId: "સ્કેન આઈડી",
            language: "ભાષા",
            settings: "સેટિંગ્સ",
            cadresLabel: "કેડર",
            masterSearchLabel: "માસ્ટર સર્ચ",
            reportsLabel: "રિપોર્ટ્સ",
            slipSendingReport: "સ્લિપ પ્રચાર રિપોર્ટ",
            surveyWiseReport: "સર્વે રિપોર્ટ",
            survey: "સર્વે",
            callCenterReport: "કૉલ સેન્ટર સર્વેક્ષણ રિપોર્ટ",
            communicationLabel: "સંચાર અને જૂથો",
            myPhonebook: "મારી ફોનબુક",
            myGroup: "મારા મતદાર",
            surnameGroup: "સરનેમ ગ્રુપ",
            preferencesLabel: "પસંદગીઓ",
            adminBadge: "એડમિન",
            wallet: "વૉલેટ",
            logoutConfirmTitle: "લૉગઆઉટની પુષ્ટિ",
            logoutConfirmMessage: "શું તમે ખરેખર લૉગઆઉટ કરવા માંગો છો?",
            logoutCancel: "રદ કરો",
            logoutConfirm: "હા, લૉગઆઉટ કરો",
            bulkSlipPrint: "બલ્ક સ્લિપ પ્રિન્ટ",
            changeResp: "જવાબદારી બદલો",
            partyCader: "પાર્ટી કેડર",
            personalCader: "ઉમેદવાર કેડર",
            beneficiary: "લાભાર્થી",
            liveVoting: "લાઇવ વોટિંગ",
            bulkPrachar: "બલ્ક પ્રચાર",
            pracharMaster: "પ્રચાર માસ્ટર",
            starVolunteer: "સ્ટાર વોલંટિયર",
            allUsers: "તમામ યુઝર્સ",
            helpVideo: "હેલ્પ વિડિયો",
            socialMedia: "યુવા અને સોશિયલ મીડિયા",
            mySlipSending: "મારી સ્લિપ",
            myPhonebookSlip: "મારી ફોનબુક સ્લિપ",
            voterCaptain: "વોટર કેપ્ટન",
            warroomPramukh: "વોરરૂમ પ્રમુખ",
            boothCaptain: "બૂથ કેપ્ટન",
            liveVotingUser: "લાઇવ વોટિંગ યુઝર",
            myOrganization: "મારું સંગઠન",
            myVoter: "મારા મતદાર",
            voterList: "મતદાર યાદી",
            socialUpdate: "સોશિયલ અપડેટ",
            profile: "પ્રોફાઇલ"
        }
    };

    const currentLang = language === 'gu' ? 'en' : (language || 'en');
    const txt = t[currentLang] || t.en;

    useEffect(() => {
        if (language === 'gu' && setLanguage) {
            setLanguage('en');
        }
    }, [language, setLanguage]);

    useEffect(() => {
        const checkAuthentication = () => {
            const storedAppId = localStorage.getItem('appId');
            const storedUserId = localStorage.getItem('userId');

            if (!storedAppId || !storedUserId) {
                navigate('/', { replace: true });
                return false;
            }

            // --- THE FIX: Instantly sync missing Context from LocalStorage upon login redirect ---
            if (!userType && setUserType) {
                const storedRole = localStorage.getItem('userType') || localStorage.getItem('designation') || localStorage.getItem('role');
                if (storedRole) setUserType(storedRole);
            }

            // Restore other context values if they're empty but localStorage has values
            if (!userName && storedUserId) {
                const storedUserName = localStorage.getItem('userName');
                const storedUserPhoto = localStorage.getItem('userPhoto');
                const storedTotalVoters = localStorage.getItem('totalVoters');

                if (storedUserName && setUserName) setUserName(storedUserName);
                if (storedUserPhoto && setUserPhoto) setUserPhoto(storedUserPhoto);
                if (storedAppId && setAppId) setAppId(storedAppId);
                if (storedUserId && setUserId) setUserId(storedUserId);
                if (storedTotalVoters && setTotalVoters) setTotalVoters(storedTotalVoters);
            }

            return true;
        };

        const timer = setTimeout(() => {
            const isAuthenticated = checkAuthentication();
            setIsLoading(!isAuthenticated);
        }, 100);

        return () => clearTimeout(timer);
    }, [navigate, userName, setUserName, setUserPhoto, setAppId, setUserId, setTotalVoters, userType, setUserType]);

    useEffect(() => {
        if (isMobileOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isMobileOpen]);

    const handleLogout = () => {
        const isConfirmed = window.confirm(txt.logoutConfirmMessage);
        if (isConfirmed) {
            logout();
            navigate('/login', { replace: true });
        }
    };

    const handleNavClick = () => {
        setIsMobileOpen(false);
    };

    // --- THE FIX: Read instantly from localStorage if context is catching up! ---
    const getDisplayRole = () => {
        if (!activeRole) return txt.adminBadge;

        if (roleCode === 'A' || roleCode === 'ADMIN') return txt.admin;
        if (roleCode === 'SA' || roleCode === 'SUB_ADMIN') return txt.subAdmin;
        if (roleCode === 'BP' || roleCode === 'BOOTH_PRAMUKH') return txt.boothPramukh;
        if (roleCode === 'K' || roleCode === 'KARYAKARTA') return txt.volunteers;
        if (roleCode === 'BS' || roleCode === 'SAH_BOOTH_PRAMUKH') return txt.sahBoothPramukh;
        if (roleCode === 'SP' || roleCode === 'SHAKTI_KENDRA') return txt.shaktiKendra;
        if (roleCode === 'CL' || roleCode === 'CALL_CENTER') return txt.callCenter;
        if (roleCode === 'VC' || roleCode === 'VOTER_CAPTAIN') return txt.voterCaptain;
        if (roleCode === 'WP' || roleCode === 'WARROOM_PRAMUKH') return txt.warroomPramukh;
        if (roleCode === 'BC' || roleCode === 'BOOTH_CAPTAIN') return txt.boothCaptain;
        if (roleCode === 'LV' || roleCode === 'LIVE_VOTING') return txt.liveVotingUser;
        return activeRole;
    };

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#0f172a', color: 'white' }}>
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <>
            <button className="mobile-menu-btn custom-mobile-btn" onClick={() => setIsMobileOpen(true)} aria-label="Open Menu">
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </button>

            {isMobileOpen && (
                <div className="sidebar-overlay" onClick={() => setIsMobileOpen(false)} />
            )}

            <div className={`sidebar-container ${isMobileOpen ? 'open' : ''}`}>
                <button className="mobile-close-btn" onClick={() => setIsMobileOpen(false)}>
                    <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                </button>

                <div className="sidebar-header">
                    <div className="logo-icon">
                        <div className="brand-icon">
                            <img src="/favicon.jpeg" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} alt="BJP Logo" />
                        </div>
                    </div>
                    <div className="logo-text-group">
                        <span className="logo-title">Vajra</span>
                        <span className="logo-subtitle"></span>
                    </div>
                </div>

                <div className="scrollable-content">
                    {/* Dashboard */}
                    <div className="nav-section">
                        <Link to='/' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                            </svg>
                            <span>{txt.dashboard}</span>
                        </Link>
                    </div>

                    {/* Cadres Section - Admin/SubAdmin View */}
                    {(isAdmin || isSubAdmin) && (
                        <>
                            <div className="section-label">{txt.cadresLabel}</div>
                            <div className="nav-section">
                                <Link to='/admin' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>
                                    <span>{txt.admin}</span>
                                </Link>
                                <Link to='/sub_admin' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                                    <span>{txt.subAdmin}</span>
                                </Link>
                                <Link to='/party_cader' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
                                    <span>{txt.partyCader}</span>
                                </Link>
                                <Link to='/personal_cader' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                    <span>{txt.personalCader}</span>
                                </Link>

                                <Link to='/dis_call_center_user' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M3 18v-6a9 9 0 0118 0v6" /><path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z" /></svg>
                                    <span>{txt.callCenter}</span>
                                </Link>
                                {/* Bulk Prachar hidden */}
                            </div>
                        </>
                    )}

                    {/* Booth Captain Section */}
                    {isBoothCaptain && (
                        <>
                            <div className="section-label">{txt.cadresLabel}</div>
                            <div className="nav-section">
                                <Link to='/dis_booth_captain_cadre_with_voter' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
                                    <span>{txt.myOrganization}</span>
                                </Link>
                                <Link to='/voter' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                    <span>{txt.myVoter}</span>
                                </Link>
                                <Link to='/display_karyakarta' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                    <span>{txt.volunteers}</span>
                                </Link>
                            </div>
                        </>
                    )}

                    {/* Warroom Pramukh Section */}
                    {isWarroomPramukh && (
                        <>
                            <div className="section-label">{txt.cadresLabel}</div>
                            <div className="nav-section">
                                <Link to='/dis_booth_captain' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
                                    <span>{txt.myOrganization}</span>
                                </Link>
                                <Link to='/shakti_kendra_voter' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                    <span>{txt.myVoter}</span>
                                </Link>
                                <Link to='/display_karyakarta' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                    <span>{txt.volunteers}</span>
                                </Link>
                            </div>
                        </>
                    )}

                    {/* Voter Captain Section */}
                    {isVoterCaptain && (
                        <>
                            <div className="section-label">{txt.cadresLabel}</div>
                            <div className="nav-section">
                                <Link to='/dis_voter_captain_voter' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                    <span>{txt.myVoter}</span>
                                </Link>
                            </div>
                        </>
                    )}

                    {/* Shakti Kendra Section */}
                    {isShaktiKendra && (
                        <>
                            <div className="section-label">{txt.cadresLabel}</div>
                            <div className="nav-section">
                                <Link to='/booth_of_shakti_kendra' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                                    <span>{txt.boothPramukh}</span>
                                </Link>
                                <Link to='/shakti_kendra_voter' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                    <span>{txt.matdar || txt.myVoter}</span>
                                </Link>
                                <Link to='/display_karyakarta' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                    <span>{txt.karyakartaBP || txt.volunteers}</span>
                                </Link>
                            </div>
                        </>
                    )}

                    {/* Booth Pramukh / Sah Booth Pramukh Section */}
                    {(isBoothPramukh || isSahBoothPramukh) && (
                        <>
                            <div className="section-label">{txt.cadresLabel}</div>
                            <div className="nav-section">
                                <Link to='/orgaization' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                                    <span>{txt.sangathan || "Organization"}</span>
                                </Link>
                                <Link to='/voter' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                    <span>{txt.matdar || txt.myVoter}</span>
                                </Link>
                                <Link to='/display_karyakarta' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                    <span>{txt.karyakartaBP || txt.volunteers}</span>
                                </Link>
                            </div>
                        </>
                    )}

                    {/* Voter List - Common for many roles */}
                    {(isAdmin || isSubAdmin || isShaktiKendra || isBoothPramukh || isSahBoothPramukh || isBoothCaptain || isWarroomPramukh || isVoterCaptain || isKaryakarta) && (
                        <div className="nav-section">
                            <Link to='/voter_list' className="nav-item" onClick={handleNavClick}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                                <span>{txt.voterList}</span>
                            </Link>
                        </div>
                    )}

                    {/* Communication Section - Groups for various roles */}
                    {(isAdmin || isSubAdmin || isBoothPramukh || isShaktiKendra || isSahBoothPramukh || isBoothCaptain || isWarroomPramukh || isVoterCaptain || isKaryakarta) && (
                        <>
                            <div className='section-label'>{txt.communicationLabel}</div>
                            <div className='nav-section'>
                                <Link to='/dis_contact_group_member' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M4 4h12a2 2 0 0 1 2 2v14l-4-2-4 2-4-2-4 2V6a2 2 0 0 1 2-2z" /><path d="M9 8h6M9 12h6" /></svg>
                                    <span>{txt.myPhonebook}</span>
                                </Link>
                                <Link to='/dis_surname_group' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 11h-6M19 8v6" /></svg>
                                    <span>{txt.surnameGroup}</span>
                                </Link>
                                <Link to='/dis_my_group_member' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
                                    <span>{txt.myGroup}</span>
                                </Link>
                                <Link to='/dis_my_slip_sending_voter' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M22 2L11 13" /><path d="M22 2l-7 20-4-9-9-4 20-7z" /></svg>
                                    <span>{txt.mySlipSending}</span>
                                </Link>
                            </div>
                        </>
                    )}

                    {/* Master Search Section */}
                    <div className='section-label'>{txt.masterSearchLabel}</div>
                    <div className='nav-section'>
                        <Link to='/master_search' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                            <span>{txt.masterSearch}</span>
                        </Link>
                        <Link to='/speak_and_search' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" /></svg>
                            <span>{txt.speakSearch}</span>
                        </Link>
                        <Link to='/quick_search' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                            <span>{txt.quickSearch}</span>
                        </Link>
                        <Link to='/display_total_booth' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" /></svg>
                            <span>{txt.boothWise}</span>
                        </Link>
                        <Link to='/display_polling_location_wise_voters' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                            <span>{txt.pollingWise}</span>
                        </Link>
                        <Link to='/age_wise_search' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                            <span>{txt.ageWise}</span>
                        </Link>
                        <Link to='/dis_all_surname' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" /></svg>
                            <span>{txt.surnameWise}</span>
                        </Link>
                        <Link to='/scan_id' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M3 8V6a2 2 0 012-2h2M3 16v2a2 2 0 002 2h2m14-12h-2a2 2 0 00-2-2h-2m6 10v2a2 2 0 01-2 2h-2" /></svg>
                            <span>{txt.scanId}</span>
                        </Link>
                    </div>

                    {/* Reports Section */}
                    <div className='section-label'>{txt.reportsLabel}</div>
                    <div className='nav-section'>
                        <Link to='/get_total_slip_distribution_count' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg>
                            <span>{txt.slipSendingReport}</span>
                        </Link>
                        <Link to='/dis_survey_dash_for_admin' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                            <span>{txt.surveyWiseReport}</span>
                        </Link>

                        {isKaryakarta && (
                            <>
                                <Link to='/dis_my_slip_sending_voter' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg>
                                    <span>{txt.mySlipSending}</span>
                                </Link>
                                <Link to='/vol_phonebook_wise_slip_send' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                                    <span>{txt.myPhonebookSlip}</span>
                                </Link>
                            </>
                        )}
                    </div>

                    {/* Beneficiary & Live Voting Section (hidden) */}

                    {/* Live Voting User Section (hidden) */}

                    {/* Social Media Section */}
                    {(isAdmin || isSubAdmin) && (
                        <>
                            <div className='section-label'>{txt.socialMedia}</div>
                            <div className='nav-section'>
                                {prachar && (
                                    <Link to='/prachar_master' className="nav-item" onClick={handleNavClick}>
                                        <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6 3 3 0 000 6z" /><path d="M18 13v4a2 2 0 01-2 2h-2" /></svg>
                                        <span>{txt.pracharMaster}</span>
                                    </Link>
                                )}
                                <Link to='/dis_star_karykarta' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>
                                    <span>{txt.starVolunteer}</span>
                                </Link>
                                <Link to='/display_posts' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M3 8V6a2 2 0 012-2h2M3 16v2a2 2 0 002 2h2m14-12h-2a2 2 0 00-2-2h-2m6 10v2a2 2 0 01-2 2h-2" /></svg>
                                    <span>{txt.socialUpdate}</span>
                                </Link>
                            </div>
                        </>
                    )}

                    {/* User Management Section */}
                    {(isAdmin || isSubAdmin) && (
                        <>
                            <div className='section-label'>{txt.userManagement}</div>
                            <div className='nav-section'>
                                <Link to='/dis_all_user' className="nav-item" onClick={handleNavClick}>
                                    <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
                                    <span>{txt.allUsers}</span>
                                </Link>
                                {/* Help Video hidden */}
                            </div>
                        </>
                    )}

                    {/* Preferences Section */}
                    <div className='section-label'>{txt.preferencesLabel}</div>
                    <div className='nav-section'>
                        <div className="nav-item" style={{ cursor: 'pointer', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                <span>{txt.language}</span>
                            </div>

                            <select
                                className="language-dropdown"
                                value={language || 'en'}
                                onChange={(e) => setLanguage(e.target.value)}
                            >
                                <option value="en">English</option>
                                <option value="hi">हिंदी</option>
                            </select>
                        </div>

                        <Link to='/chnage_responcibility' className="nav-item" onClick={handleNavClick}>
                            <span className="nav-icon"><svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg></span>
                            <span>{txt.changeResp}</span>
                        </Link>

                        <div className="nav-item" style={{ cursor: 'pointer' }} onClick={() => { navigate('/profile'); setIsMobileOpen(false); }}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                            <span>{txt.profile}</span>
                        </div>
                    </div>
                    <div className="spacer"></div>
                </div>

                <div className="user-footer">
                    <div className="user-avatar-container">
                        <div className="avatar">
                            <img src={userPhoto ? userPhoto : `https://ui-avatars.com/api/?name=${encodeURIComponent(userName || 'User')}&background=random&color=fff`} alt="User" />
                        </div>
                        <span className="online-dot"></span>
                    </div>
                    <div className="user-info">
                        <span className="user-name" style={{ color: "white", fontSize: "14px", fontWeight: "600" }}>{userName}</span>
                        <span className="user-badge">{getDisplayRole()}</span>
                    </div>
                    <button className="logout-btn" onClick={handleLogout} title={txt.logoutConfirmTitle}>
                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
                    </button>
                </div>
            </div>

            <style jsx>{`
                /* Modern Select Dropdown Styling */
                .language-dropdown {
                    background-color: rgba(255, 255, 255, 0.05);
                    color: #f8fafc;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 8px;
                    padding: 6px 28px 6px 12px;
                    font-size: 13px;
                    font-weight: 600;
                    outline: none;
                    cursor: pointer;
                    appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%2394a3b8%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E");
                    background-repeat: no-repeat;
                    background-position: right 8px center;
                    background-size: 14px;
                    transition: all 0.2s ease;
                }
                .language-dropdown:hover {
                    background-color: rgba(255, 255, 255, 0.1);
                    border-color: rgba(255, 255, 255, 0.2);
                }
                .language-dropdown:focus {                  
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.25);
                }
                .language-dropdown option {
                    background-color: #0f172a;
                    color: #f8fafc;
                    font-weight: 500;
                    padding: 8px;
                }
                
                @media (max-width: 768px) {
                    .sidebar-container { display: flex; flex-direction: column; height: 100dvh; }
                    .scrollable-content { flex: 1; overflow-y: auto; }
                    .user-footer { display: flex !important; flex-shrink: 0; margin-top: auto; z-index: 10; }
                    
                    /* Original top-right position restored */
                    .custom-mobile-btn { 
                        position: fixed; 
                        right: 20px; 
                        left: auto; 
                        z-index: 999; 
                    }
                }
            `}</style>
        </>
    );
};

export default Sidebar;